const initialState = {
  data: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'table.folders/LIST_FOLDERS_SUCCESS':
      return {
        ...state,
        data: action.response.data || [],
      };
    default:
      return state;
  }
}
